// extracted by mini-css-extract-plugin
export default {"container":"AdminCommunicationsEdit_container__5w1+D"};